export enum ETLCodes {
  Home,
  BackendError,
  BackendErrorDetailledMessage,
  NotAuthorized,
  UserNotAuthorizedMessage,
  RouteConfirmDialogTitle,
  Add,
  Save,
  SearchPlaceholder,
  SearchCriteriaPanel_AddCriteria,
  SearchCriteriaPanel_FilterRemoveCriteria,
  SearchCriteriaPanel_RemoveCriteria,
  SearchCriteriaPanel_Search,
  SearchCriteriaPanel_SearchModes_Between,
  SearchCriteriaPanel_SearchModes_Contains,
  SearchCriteriaPanel_SearchModes_EndWith,
  SearchCriteriaPanel_SearchModes_Equals,
  SearchCriteriaPanel_SearchModes_Greater,
  SearchCriteriaPanel_SearchModes_GreaterOrEquals,
  SearchCriteriaPanel_SearchModes_GreaterThan,
  SearchCriteriaPanel_SearchModes_Less,
  SearchCriteriaPanel_SearchModes_LessOrEquals,
  SearchCriteriaPanel_SearchModes_LessThan,
  SearchCriteriaPanel_SearchModes_NotContains,
  SearchCriteriaPanel_SearchModes_NotEquals,
  SearchCriteriaPanel_SearchModes_StartWith,
  SearchCriteriaPanel_SearchModes_undefined,
  SearchCriteriaPanel_Yes,
  SearchCriteriaPanel_No,
  Cancel,
  Copy,
  GoBack,
  Edit,
  Export,
  Import,
  View,
  FormDirtyCancelMessage,
  Delete,
  Confirm,
  No,
  Yes,
  GeneralNoData,
  ClickOnPictureToEdit,
  FormDirtyRouteChangeMessage,
  SaveSuccess,
  Error,
  DeletedSuccessfully,
  AreYouSureYouWantToDeleteThisItem,
  AreYouSure,
  ErrorMessage_Unauthorized_title,
  ErrorMessage_Unauthorized,
  DeleteError,
  TranslationCode,
  LanguageCode,
  Text,
  ErrorWhileImportingTranslations,
  Translations,
  TableCriterias,
  TableResults,
  GeneralLoading,
  Menu,
  UnFixMenuTooltip,
  FixMenuTooltip,
  QuickAccess,
  SelectorAvailable,
  ChooseXItems,
  UnChooseXItems,
  SelectorSelected,
  Logout,
  Administration,
  Users,
  UserList,
  NewUser,
  Details,
  FirstName,
  LastName,
  Login,
  Role,
  UserSaved,
  Required,
  ConfirmDelete,
  CreatedOn,
  UpdatedOn,
  Language,
  LockAccount,
  UnlockAccount,
  Password,
  NewPassword,
  MailTemplateList,
  NewMailTemplate,
  MailTemplates,
  MailTemplateType,
  Subject,
  Content,
  DisclaimerContent,
  DisclaimerCheckbox,
  Continue,
  WorkerTitle,
  ContactTitle,
  ReasonTitle,
  FunctionTitle,
  ArgumentationTitle,
  ConfirmTitle,
  PersonalInformation,
  InternalFunctionTitle,
  Address,
  Number,
  ZipCode,
  City,
  PostBox,
  Street,
  Country,
  Email,
  Phone,
  Mobile,
  Language_FR,
  Language_NL,
  FolderLanguage,
  Contact,
  InvalidEmailFormat,
  ExternalRemedies,
  Status,
  CreationDate,
  GeneralMotive,
  ONSS,
  CompanyName,
  MailTemplateTypes,
  UseAddress,
  Reset,
  FunctionPopOver,
  WorkerEmailToolTip,
  ManagerNameToolTip,
  Reasons,
  Reasons_Label_Text,
  PleaseArgue,
  RequestArgumentation,
  Motive41,
  Motive42,
  Motive43,
  Motive44,
  BePreciseAndComplete,
  Motive,
  Annex,
  JoinFiles,
  Download,
  FileName,
  ConfirmDeleteFile,
  UploadFile,
  ClickHereOrDropFile,
  YourFunctionAttribution,
  BaremicCategory,
  FunctionDescription,
  FunctionCode,
  MissingFunctionSelectMissing,
  InitialFunctionLabel,
  Function,
  FinalAttributionLabel,
  CurrentAttributionLabel,
  MissingFunction,
  AttributionPercentage,
  CreateAppeal,
  AttributionMustTotal100,
  Send,
  CommunidationDateLabel,
  DecisionDate,
  ConfirmCheckboxLabel,
  SubmitRequest,
  FileAlreadyExists,
  ChooseAFile,
  Browse,
  ToMakeThisReceivablePleaseAddFile,
  ProtocolExplanationText,
  DataUsageExplanationText,
  GDPRText,
  NewRequest,
  RequestList,
  DashboardContactUsText,
  InvalidIdentifiers,
  DownloadSignedDoc,
  AddNewFunction,
  Employer,
  EmployerIdentification,
  GeneralInformations,
  OnssCode,
  ONSSToolTip,
  InvalidMobilePhoneFormat,
  MailSent,
  EmailDoesntExist,
  SendPasswordRecoveryEmail,
  PasswordReset,
  PasswordConfirmation,
  PasswordMustMatch,
  ForgottenPassword,
  SignUp,
  NoProblemFillFormBelow,
  MustBeNumber,
  Validate,
  StepNotCompletedError,
  Public,
  ProtocolExplanationTitle,
  DataUsageExplanationTitle,
  ThisLink,
  BeforeCompletingAndSiningIntroText,
  FunctionWithinInstitution,
  DepartmentOrServiceOrUnit,
  AnnexExplanation,
  InitialFunctionHelperText,
  CurrentFunctionHelperText,
  CommunicationDateHelperText,
  DecisionDateHelperText,
  RequestFinalisationTitle,
  RequestFinalisationText,
  Ok,
  EmployerFormInfo,
  ContactInfo,
  NotAnEmployeeWarning,
  EmployeeValidationFinalized,
  SigningPageUnavailable,
  LoginWarningMessage,
  ContactInformations,
  YourEmployer,
  FillOnlyIfDifferent,
  AtLeastOneFileRequired,
  JoinCopyOfDecision,
  LogoutConfirmationMessage,
  SectorType,
  Region,
  Editable,
  SharepointId,
  ShowPassword,
  HidePassword,
}
